import {CsForm}              from "@Common/react/cs-form/cs-form";
import {makeLengthValidator} from "@Common/react/cs-form/validators/length";
import {Types}               from "@Common/types";
import {fromEntries}         from "@Common/utils/objects";

type FormModel = Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.Contact.FormModel;

export const FIELD_NAMES = [
    "allowFeedUpdate" as const,
    "branchDisplay1" as const,
    "branchDisplay2" as const,
    "branchDisplay3" as const,
    "branchDisplay4" as const,
    "branchDisplay5" as const,
    "branchDisplay6" as const,
];

const FIELD_VALIDATORS:{[path in typeof FIELD_NAMES[number]]?: Types.Common.React.CsForm.Validator<FormModel, path>[]} = (() => {
    const maxLength80Validator = makeLengthValidator({max: 80});
    return fromEntries(
        Array(6)
            .fill(maxLength80Validator)
            .map((validator, index) => [`branchDisplay${index + 1}`, [validator]])
    );
})();

export const ContactFormState = ({branch, next}:{
    branch : FormModel,
    next   : (v:Types.Xpresso.Account.Admin.OfficeManagement.ManagementModal.Contact.FormStateNext) => JSX.Element,
}): React.FunctionComponentElement<any> => (
    CsForm({
        next,
        fields: FIELD_NAMES.map(path => ({
            path,
            defaultValue : branch?.[path],
            validators   : FIELD_VALIDATORS[path],
        })),
    })
);

